<div
  *ngIf="ids.length === 0"
  class="d-flex justify-content-around flex-column"
>
  <h3 class="d-flex justify-content-around">Geen (geldig) verkooporder ID gegeven.</h3>
  <div class="d-flex justify-content-around">
    <button
      class="w-25"
      (click)="returnToFreshdesk()"
    >
      Terug
    </button>
  </div>
</div>

<div
  *ngIf="error"
  class="d-flex justify-content-around flex-column"
>
  <pre class="d-flex justify-content-around">
    <h4>{{ error }}</h4>
  </pre>
  <div class="d-flex justify-content-around">
    <button
      class="w-25"
      (click)="returnToFreshdesk()"
    >
      Terug
    </button>
  </div>
</div>

<div *ngIf="ids.length !== 0 && !error">
  <h3 class="d-flex justify-content-around">Bezig met het doorzetten van de verkooporder...</h3>
  <app-loading-gears></app-loading-gears>
  <h3 class="d-flex justify-content-around">
    Zodra de verkooporder geplaatst is, wordt je teruggebracht naar de ticket in Freshdesk
  </h3>
</div>
